import React from 'react';
import { PlayedToggle } from '@/components/stats/PlayedToggle';

function RosterRow({ player, draft, onField, played, onTogglePlayed }) {
  return (
    <div className="flex items-center gap-2 bg-white/5 border border-white/10 rounded-md p-2"
      data-testid={`edit-roster-row-${player.id}`}>
      <input
        type="text"
        inputMode="numeric"
        maxLength={3}
        value={draft.jersey_number ?? ''}
        onChange={e => onField('jersey_number', e.target.value)}
        placeholder="#"
        className="w-14 text-center bg-[#0A0F2C] border border-white/15 rounded-md h-9 px-2 text-amber-300 font-bold italic focus:outline-none focus:border-amber-300"
        data-testid={`edit-roster-jersey-${player.id}`}
      />
      <input
        type="text"
        value={draft.name ?? ''}
        onChange={e => onField('name', e.target.value)}
        placeholder="Player name"
        className="flex-1 min-w-0 bg-[#0A0F2C] border border-white/15 rounded-md h-9 px-2 text-white text-sm focus:outline-none focus:border-white/50"
        data-testid={`edit-roster-name-${player.id}`}
      />
      {played !== undefined && (
        <PlayedToggle played={played} onToggle={onTogglePlayed} testId={`edit-roster-played-${player.id}`} />
      )}
    </div>
  );
}

export function EditRosterTeam({ teamKey, team, drafts, onField, playedDraft, onTogglePlayed }) {
  const players = team.players || [];
  return (
    <div className="mt-4" data-testid={`edit-roster-team-${teamKey}`}>
      <div className="text-[11px] uppercase tracking-widest text-amber-300 font-bold mb-2">{team.name}</div>
      <div className="space-y-2">
        {players.map(p => (
          <RosterRow
            key={p.id}
            player={p}
            draft={drafts[p.id] || {}}
            onField={(field, value) => onField(teamKey, p.id, field, value)}
            played={p.id in playedDraft ? playedDraft[p.id] : undefined}
            onTogglePlayed={() => onTogglePlayed(p.id)}
          />
        ))}
        {players.length === 0 && (
          <div className="text-white/40 text-xs italic px-2 py-4">No players on this team.</div>
        )}
      </div>
    </div>
  );
}
